module.exports = __webpack_public_path__ + "static/media/unterweisungen_start.4aec7666.jpg";